import { Box, Chip, LinearProgress, linearProgressClasses, Paper, Stack } from "@mui/material";
import React from "react";
import styled from "styled-components";

const BadgeBackground = styled(Stack)`
    width: 68px;
    height: 68px;
    background-color: #424242;
    padding: 5px;
    border-radius: 14px;
`;

const AchievementBackground = styled(Paper)`
    border-radius: 14px;
`;

const BadgesDescriptionLetters = styled.h4`
    font-size: 12px;
    font-weight: 200;
    min-height: 50px;
    margin: 0;
`;

const ProgressLetters = styled.span`
    font-size: 12px;
    font-weight: 300;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const HelperLetters = styled.h3`
    font-size: 12px;
    font-weight: 500;
    margin: 0;
`;

const TierChip = styled(Chip)`
    z-index: 100;
    background: #000000ad;
    border-radius: 4px;
    & span {
        padding-left: 4px;
        padding-right: 4px;
        font-size: 11px;
    }
`;

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 18,
    width: "100%",
    backgroundColor: "#505050",
    borderRadius: 6,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        background: "linear-gradient(to right, #59C36A, #4caf5024)",
    },
}));

const TierChipAssign = ({ achievement }) => {
    if (achievement && achievement.achievementId.includes("tier2")) {
        return <TierChip size="small" label="Tier 2" />;
    }
    if (achievement && achievement.achievementId.includes("tier3")) {
        return <TierChip size="small" label="Tier 3" />;
    }
    if (achievement && achievement.achievementId.includes("tier4")) {
        return <TierChip size="small" label="Tier 4" />;
    }
    return null;
};

const BadgeAchieventOverview = ({ achievement }) => {
    if (!achievement) return null;

    const isProd = process.env.ENVIRONMENT_NAME === "prod";
    const setAssetLink = () => {
        if (!isProd) return "https://assets-sit.adadot.com/achievements";
        return "https://assets.adadot.com/achievements";
    };

    const assetLink = setAssetLink();

    return (
        <Stack direction="column" alignItems="center" maxWidth="278px" margin={1}>
            <AchievementBackground>
                <Stack
                    key={achievement.name}
                    minHeight="100px"
                    direction="row"
                    alignItems="center"
                    p={1}
                >
                    <BadgeBackground direction="column" spacing={-2}>
                        <Box
                            component="img"
                            sx={{
                                height: "58px",
                                width: "58px",
                                borderRadius: "12px",
                            }}
                            alt={achievement.name}
                            src={`${assetLink}/${achievement.category}/${achievement.achievementId}.png`}
                            loading="lazy"
                        />
                        {TierChipAssign({ achievement })}
                    </BadgeBackground>
                    <Stack direction="column" pl={1} pr={2} width="192px">
                        <HelperLetters>{achievement.name}</HelperLetters>
                        <BadgesDescriptionLetters>
                            {achievement.description}
                        </BadgesDescriptionLetters>
                        <Stack
                            direction="row"
                            spacing={0.5}
                            style={{ width: "100%" }}
                            justifyContent="flex-start"
                            alignItems="center"
                        >
                            <div
                                style={{
                                    width: "100%",
                                    position: "relative",
                                }}
                            >
                                <BorderLinearProgress
                                    variant="determinate"
                                    value={
                                        (achievement.progress.progress / achievement.target) * 100
                                    }
                                />
                                <ProgressLetters>
                                    {achievement.progress.progress} / {achievement.target}
                                </ProgressLetters>
                            </div>
                        </Stack>
                    </Stack>
                </Stack>
            </AchievementBackground>
        </Stack>
    );
};
export default BadgeAchieventOverview;
